import React from 'react';
import {
 TextInput, SearchInput, DropDown, PrimaryButton, Pulse
} from 'wf-react-component-library';
import { getItemsByCriteria } from '../api/p3/ItemApi';
import './Premiums.scss';
import { Logger } from '@aws-amplify/core';
import { validatePremium, validatePremiumItem } from '../services/validation/VirmItem';

const logger = new Logger('Premiums.js');

class Premiums extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: this.props.selectedItem.premium && this.props.selectedItem.premium.value,
            items: [],
            searchItems: [],
            selectedItem: this.props.selectedItem,
            selectedPremium: this.props.selectedItem.premium && this.props.selectedItem.premium.itemId ? this.props.selectedItem.premium.itemId : null,
            premiumUnitOptions: {
                "CTN": "CTN",
                "WT": "WT",
                "STEM": "STEM"
            },
            displayPremiums: false,
            isLoading: false,
            isAvailableFilterOn: false,
            isUnavailableFilterOn: false
        };

        this.handleExpander = this.handleExpander.bind(this);
        this.handleDisplayPremiums = this.handleDisplayPremiums.bind(this);
        this.handlePremiumSelection = this.handlePremiumSelection.bind(this);
        this.handleDeletePremium = this.handleDeletePremium.bind(this);
        this.handleUnitChange = this.handleUnitChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterByAvailability = this.handleFilterByAvailability.bind(this);
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.selectedItem.vendorItemId !== prevProps.selectedItem.vendorItemId) {
            const selectedItem = this.props.selectedItem;
            const isExpanded = this.props.selectedItem.premium && this.props.selectedItem.premium.value;
            const selectedPremium = this.props.selectedItem.premium && this.props.selectedItem.premium.itemId ? this.props.selectedItem.premium.itemId : null;
            this.setState({selectedItem, isExpanded, selectedPremium});
        }
    }

    handleExpander = () => {
        const { isExpanded, selectedItem } = this.state;
        selectedItem.premium = selectedItem.premium ?? {};
        this.setState({isExpanded: !isExpanded});
    }
    
    handleDisplayPremiums = async () => {
        const { displayPremiums } = this.state;
        this.setState({ isLoading: true });
        let resp = [];

        // if displayPremiums is false, we will be changing it to true so we need to query for the premiums
        if (!displayPremiums) {
            const selectedVendorCategory = this.props.currentVendorCategory[0];
            let selectedVendorCategoryId = '0';
            let groupCode = '';
            let commodityId = 0;

            if (selectedVendorCategory == 'meat') {
                selectedVendorCategoryId = '2';
                groupCode = 'MB';
                commodityId = 188;
            } else if (selectedVendorCategory == 'produce') {
                selectedVendorCategoryId = '3';
                groupCode = 'M';
                commodityId = 147;
            } else if (selectedVendorCategory == 'seafood') {
                selectedVendorCategoryId = '1';
                groupCode = 'SB';
                commodityId = 174;
            }

            const criteria = {
                category: selectedVendorCategoryId,
                group: groupCode,
            };
            
            try {
                resp = await getItemsByCriteria(criteria);
                resp = resp.filter((i) => i.commodityId != commodityId);
            } catch (ex) {
                logger.debug(`%cThere was an error retrieving the premiums:`,'font-weight: bold; color: red;');
                logger.debug(ex);
            }
        }

        this.setState({ 
            items: resp,
            searchItems: resp,
            displayPremiums: !displayPremiums,
            isLoading: false,
            isAvailableFilterOn: false,
            isUnavailableFilterOn: false
        });
    }

    handlePremiumSelection = (item) => {
        const { selectedItem } = this.state;
        selectedItem.premium.itemId = item.itemId;
        selectedItem.premium.itemCode = item.itemCode;
        selectedItem.premium.description = item.description;

        this.props.handlePremiumChange(selectedItem.premium);

        this.setState({ selectedItem, selectedPremium: item.itemId, displayPremiums: false });
    }

    handleDeletePremium = () => {
        const { selectedItem } = this.state;
        selectedItem.premium = {};

        this.props.handlePremiumChange(selectedItem.premium);

        this.setState({ selectedPremium: null, selectedItem });
    }

    handleUnitChange = (e) => {
        const { selectedItem } = this.state;
        if(e.target.value){
            selectedItem.premium.value = "0.00";
            selectedItem.premium.type = "cost";
            selectedItem.premium.unitType = e.target.value;
        }else{
            delete selectedItem.premium.value;
            delete selectedItem.premium.type;
            delete selectedItem.premium.unitType;
        }

        this.props.handlePremiumChange(selectedItem.premium);

        this.setState({ selectedItem });
    }

    handleCostChange = (e) => {
        const { selectedItem } = this.state;
        selectedItem.premium.value = e.target.value;
        selectedItem.premium.type = "cost";
        
        this.props.handlePremiumChange(selectedItem.premium);
        this.setState({ selectedItem });
    }

    handlePercentChange = (e) => {
        const { selectedItem } = this.state;
        selectedItem.premium.value = e.target.value;
        selectedItem.premium.type = "percent";
        
        this.props.handlePremiumChange(selectedItem.premium);
        this.setState({ selectedItem });
    }

    handleSearchChange = (e) => {
        const searchCriteria = e.target.value;
        let searchItems = [];
        const { items } = this.state;
        if (searchCriteria.length > 2) {
          // check for comma separated search input.
          if (searchCriteria.includes(',')) {
            searchCriteria.split(',')
              .map((item) => item.trim())
              .forEach((searchTerm) => {
                searchItems.push(items.filter((item) => item.itemCode.toString().includes(searchTerm)
                  || (item.description != null && item.description.toLowerCase()
                    .includes(searchTerm.toLowerCase()))));
              });
    
            this.setState({ searchItems });
          } else {
            searchItems = items.filter((item) => item.itemCode.toString().includes(searchCriteria)
              || (item.description != null && item.description.toLowerCase()
                .includes(searchCriteria.toLowerCase())));
    
            this.setState({ searchItems });
          }
        } else {
          this.setState({ searchItems: this.state.items });
        }
    }
    
    clearSearch = () => this.setState({
        searchItems: this.state.items,
        isAvailableFilterOn: false,
        isUnavailableFilterOn: false
    });

    handleFilterByAvailability = (option) => {
        // 0 => Available
        // 1 => Unavailable
        const { isAvailableFilterOn, isUnavailableFilterOn, searchItems, items } = this.state;
        let newSearchItems;
        const availableFilterOn = option === 0 ? !isAvailableFilterOn : isAvailableFilterOn;
        const unavailableFilterOn = option === 1 ? !isUnavailableFilterOn: isUnavailableFilterOn;
    
        if (availableFilterOn && unavailableFilterOn) {
          newSearchItems = items;
        } else if (!availableFilterOn && unavailableFilterOn) {
          newSearchItems = searchItems.filter(item => item.availableFlag === false);
        } else if (availableFilterOn && !unavailableFilterOn) {
          newSearchItems = searchItems.filter(item => item.availableFlag === true);
        } else {
          newSearchItems = items;
        }
    
        this.setState({ isUnavailableFilterOn: unavailableFilterOn, isAvailableFilterOn: availableFilterOn, searchItems: newSearchItems });
      }

    render() {
        const {
            isExpanded,
            items,
            searchItems,
            selectedItem,
            premiumUnitOptions,
            displayPremiums,
            selectedPremium,
            isLoading
        } = this.state;

        const summaryCounts = searchItems.length === items.length
            ? `${items.length} Total Items`
            : `Search Returned ${searchItems.length} of ${items.length} Total Items`;

        const currentPremiumDescription = selectedPremium !== null ? selectedItem.premium.description : "";
        const currentPremiumItemCode = selectedPremium !== null ? selectedItem.premium.itemCode : "";

        const rows = searchItems.map((item) => {
            const className = item.itemId === selectedPremium ? "selected" : "";
            const itemRowClassName = `item-row ${className}`;
            return (
                <tr key={item.itemId} className={itemRowClassName} onClick={() => this.handlePremiumSelection(item)}>
                    <td style={{textAlign: 'center', paddingLeft: '0px'}}>
                        { item.availableFlag
                        ? "Available"
                        : <span style={{color:"red"}}>Unavailable</span>
                        }
                    </td>
                    <td>
                        <span className="body-short-form">{item.itemCode}</span>
                    </td>
                    <td>
                        <span className="body-short-form">{item.description}</span>
                    </td>
                </tr>
            );
        });

        return (
            <div className="flex-container-row premiums-container">
                <div className="flex-container-column premiums-view">
                    <div className="flex-container-row banner" onClick={this.handleExpander}>
                        <div className="flex-container-column premiums-banner">
                            Add/Edit Premiums
                        </div>
                        <div className="flex-container-column expander">
                            { isExpanded
                                ? '-'
                                : '+'
                            }
                        </div>
                    </div>
                    { isExpanded
                        ? <div className="flex-container-row premiums-search">
                                { this.props.premiumErrorMessages.countryOfOrigin
                                    ? <div className="error-msg">Please finish item set up before adding item premium</div>
                                    : null
                                }
                                <div className="flex-container-row" style={{"width": "100%"}}>
                                     { selectedPremium !== null
                                     ? <div className="flex-container-row current-premium">
                                        <span>Current Premium:</span>
                                        <span className="premium-description">{`${currentPremiumItemCode} - ${currentPremiumDescription}`}</span>
                                        <span className="delete-premium" title="Delete Current Premium" onClick={this.handleDeletePremium}>X</span>
                                      </div>
                                     : null
                                    }
                                    <div className="flex-container-row premium-settings">
                                        <div className="flex-container-column input">
                                            <DropDown id="premiumUnit" placeHolderDisabled={false} labelName="Unit Type" errorMsg={this.props.premiumErrorMessages.unitType} value={selectedItem.premium.unitType ? selectedItem.premium.unitType : ''} options={premiumUnitOptions} placeHolderText="Select a Unit" handleChange={this.handleUnitChange} />
                                        </div>
                                        { selectedItem.premium.unitType === 'STEM'
                                          ? <div className="flex-container-column input">
                                                <TextInput isDisabled={!!+selectedItem.premium.value && selectedItem.premium.type == "cost"} errorMsg={this.props.premiumErrorMessages.value} value={selectedItem.premium.type == "percent" ? selectedItem.premium.value.toString() : '0'} labelName="Percent" id="premiumPercent" handleChange={this.handlePercentChange}/>
                                            </div>
                                          : null
                                        }    
                                        { ['WT','CTN','STEM'].some((val) => val === selectedItem.premium.unitType )
                                          ? <div className="flex-container-column input">
                                                <TextInput isDisabled={!!+selectedItem.premium.value && selectedItem.premium.type == "percent"} errorMsg={this.props.premiumErrorMessages.value} value={selectedItem.premium.type == "cost" ? selectedItem.premium.value.toString() : '0.00'} labelName="Cost" id="premiumCost" handleChange={this.handleCostChange}/>
                                            </div>
                                          : null
                                        }                         
                                        <div className="flex-container-column input" style={{"marginTop": "15px"}}>
                                            <PrimaryButton onClick={this.handleDisplayPremiums} name="Select a Premium" />
                                        </div>
                                        { this.props.premiumErrorMessages.description
                                            ? <div className='error-msg'>{'Please select a premium from the list'}</div>
                                            : null 
                                        }
                                    </div>
                                { displayPremiums && !isLoading && items.length > 0
                                  ? <div className="flex-container-row add-item-table-container show">
                                        <div className="flex-container-row search-container" style={{"width": "100%"}}>
                                            <div className="flex-container-column" style={{"width": "100%"}}>
                                                <div className="flex-container-row add-item-count">
                                                <div className="flex-container-column">
                                                    <div className="flex-container-row">
                                                    <div className="flex-container-column">
                                                        <SearchInput id="item-search" clearSearch={this.clearSearch} handleChange={this.handleSearchChange} placeHolderText="Search By Item Code or Description" />
                                                    </div>
                                                    <div className="flex-container-column">
                                                        <button className={this.state.isAvailableFilterOn ? "available-filter" : "available-filter not-filtered"} onClick={() => this.handleFilterByAvailability(0)}>
                                                            { this.state.isAvailableFilterOn ? "Available" : "Show Available" }
                                                        </button>
                                                    </div>
                                                    <div className="flex-container-column">
                                                        <button className={this.state.isUnavailableFilterOn ? "available-filter" : "available-filter not-filtered"} onClick={() => this.handleFilterByAvailability(1)}>
                                                            { this.state.isUnavailableFilterOn ? "Unavailable" : "Show Unavailable" }
                                                        </button>
                                                    </div>
                                                    </div>   
                                                </div>
                                                
                                                <div className="flex-container-column">
                                                    <div className="container-row">{summaryCounts}</div>
                                                </div>             
                                                </div>                                      
                                            </div>                    
                                        </div>
                                        <div className="item-table add">
                                        <table className="item-table" cellPadding="0" cellSpacing="0" width="100%">
                                            <colgroup>
                                            <col span="1" style={{ width: '5%' }} />
                                            <col span="1" style={{ width: '10%' }} />
                                            <col span="1" style={{ width: '30%' }} />
                                            </colgroup>

                                            <tbody>
                                            <tr className="item-table-header">
                                                <td className="available-column">
                                                    P3 Status
                                                </td>
                                                <td>Item Code</td>
                                                <td>Full Description</td>
                                            </tr>
                                            {rows}
                                            </tbody>
                                        </table>
                                        </div>
                                </div>
                                : null
                                }
                                { displayPremiums && !isLoading && items.length === 0
                                    ? <div className="flex-container-row add-item-table-container show">No Items Found</div>
                                    : null
                                }
                                <div className="flex-container-row premium-settings" style={{"width": "100%"}}>
                                    <div className="flex-container-column input">
                                        Note: Adding a new premium to this item(s) will replace the existing premium.
                                    </div>
                                </div>
                                </div>
                             { displayPremiums && isLoading
                                ? <div className="flex-container-row add-item-table-container show">
                                    <Pulse text="Loading Premiums..." />
                                </div>  
                                : null
                             }
                        </div>
                        : null
                    }
                </div>            
            </div>
        )
    }
}

export default Premiums;